import AddIcon from "@mui/icons-material/Add"
import CloseIcon from "@mui/icons-material/Close"
import { Box, Button, Chip, IconButton, TextField, Typography } from "@mui/material"
import { Control, Controller, useFieldArray, useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { IOrder, IOrderPrintInk } from "./types"

export default function InksSection({ control, side, title }: {
    control: Control<IOrder>
    side: "A" | "B"
    title: string
}) {
    const { t } = useTranslation()
    const { fields, append, update } = useFieldArray({ control, name: "order_print_inks" })
    const allInks = useWatch({ control, name: "order_print_inks" }) as IOrderPrintInk[]

    const handleRemove = (index: number) => {
        const e = allInks[index]
        update(index, { ...e, _destroy: true })
    }

    const activeFields = fields
        .map((f, i) => ({ ...f, _idx: i }))
        .filter((_, i) => !(allInks[i]?._destroy) && allInks[i]?.side === side)

    const chips = allInks.filter(i => !i._destroy && i.color_name && i.side === side)

    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5, mb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>{title}</Typography>
                {chips.map((i, idx) => <Chip key={idx} label={i.color_name} size="small" />)}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {activeFields.map(({ _idx: idx }, position) => (
                    <Box key={idx} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                        <Controller
                            control={control}
                            name={`order_print_inks.${idx}.color_name` as keyof IOrder}
                            render={({ field }) => (
                                <TextField {...field} label={`Color ${position + 1}`} size="small" sx={{ flex: 1 }} />
                            )}
                        />
                        <IconButton size="small" color="error" onClick={() => handleRemove(idx)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                ))}
                <Button
                    size="small"
                    startIcon={<AddIcon />}
                    sx={{ alignSelf: "flex-start" }}
                    onClick={() => append({ id: 0, color_name: "", side, _destroy: false })}
                >
                    {t("orders.form.addInk")}
                </Button>
            </Box>
        </Box>
    )
}
